import { render, staticRenderFns } from "./ViewItemOverlay.vue?vue&type=template&id=39f838d1&scoped=true"
import script from "./ViewItemOverlay.vue?vue&type=script&lang=js"
export * from "./ViewItemOverlay.vue?vue&type=script&lang=js"
import style0 from "./ViewItemOverlay.vue?vue&type=style&index=0&id=39f838d1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f838d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f838d1')) {
      api.createRecord('39f838d1', component.options)
    } else {
      api.reload('39f838d1', component.options)
    }
    module.hot.accept("./ViewItemOverlay.vue?vue&type=template&id=39f838d1&scoped=true", function () {
      api.rerender('39f838d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/browser/item-overlays/ViewItemOverlay.vue"
export default component.exports